import { EMPLOYEE_TYPES_ALIAS } from '../constants';
import { ACTIVE_STATUS, IN_DISMISSAL_STATUS, RELOCATION_STATUS } from '../model';
import EmployeeInput, { EmployeeInputProps } from './EmployeeInput';

interface NotDismissedEmployeeInputProps extends EmployeeInputProps {
  includeContractors?: boolean;
  includeInterns?: boolean;
  errorSource?: string;
}

const NotDismissedEmployeeInput = ({
  includeContractors,
  includeInterns,
  ...props
}: NotDismissedEmployeeInputProps) => {
  return (
    <EmployeeInput
      defaultFilter={{
        workingStatus: { in: [ACTIVE_STATUS, IN_DISMISSAL_STATUS, RELOCATION_STATUS] },
        employeeType: {
          in: [
            includeContractors ? EMPLOYEE_TYPES_ALIAS.CONTRACTOR : null,
            includeInterns ? EMPLOYEE_TYPES_ALIAS.INTERN : null,
            EMPLOYEE_TYPES_ALIAS.EMPLOYEE,
          ].filter(item => !!item),
        },
      }}
      {...props}
    />
  );
};

export default NotDismissedEmployeeInput;
